export default {
  create: "Voeg een e-mail account toe",
}
